import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY } from 'components/constants/animation-properties';
import { floatingContainerSelect, transportTypeMenu } from 'data/quote';
import { useGetUser } from 'atom/user';
import { SetStateAction, useEffect, useState } from 'react';
import PortSelect from 'components/common/PortSelect';
import QuoteArea from './quoteArea';
import CustomButton from 'components/common/CustomButton';
import CustomSelect from 'components/common/CustomSelect';
import CustomInput from 'components/common/CustomInput';
import Container from 'components/common/Container';
import MainQuoteModal from 'components/common/modal/MainQuoteModal';
import BlSearch from './BlSearch';
import { ReactComponent as ChkOn } from 'assets/main/checkOn.svg'
import { ReactComponent as ChkOff } from 'assets/main/checkOff.svg'
import { IInfo } from 'types/quote';
import { ReactComponent as XMark } from 'assets/common/xmark.svg'

interface INewSecond {
    blNo: string
    setBlNo: React.Dispatch<SetStateAction<string>>
    setIsOpen: React.Dispatch<SetStateAction<boolean>>
    setLoginQuote: React.Dispatch<SetStateAction<boolean>>
    info: IInfo
    setInfo: React.Dispatch<SetStateAction<IInfo>>
}

const FloatingArea = ({ blNo, setBlNo, setIsOpen, setLoginQuote, info, setInfo }: INewSecond) => {
    const user = useGetUser();
    const [clear, setClear] = useState<boolean>(false);
    const [userPop, setUserPop] = useState<boolean>(false)
    const [tempRefresh, setTempRefresh] = useState<boolean>(false)
    const [tab, setTab] = useState<number>(0)
    const tabMenu = [
        { title: '실시간견적', tab: 0 },
        { title: 'BL 조회', tab: 1 },
    ]
    const shipment = ['FCL', 'LCL']

    useEffect(() => {
        const isSea = info.transportType === 'SEA';
        const isAir = info.transportType === 'AIR';
        let isValid = false;

        const hasCommonFields =
            !!info.transportType &&
            !!info.originCode &&
            !!info.destinationCode &&
            !!info.amount

        if (isSea) {
            if (info.shipmentMode === 'FCL') {
                isValid = info.amount! > 0 && !!info.containerType
            }
            else if (info.shipmentMode === 'LCL') {
                isValid = info.amount! > 0
            }
        }
        else if (isAir) {
            isValid = true
        }
        setClear(hasCommonFields && isValid);
    }, [info])


    const saveQuote = () => {
        if (!user.id) {
            setUserPop(true);
            return
        }
        else {
            setLoginQuote(true)
        }
    }

    return (
        <div className='top-0 left-0 z-40 lg:absolute relative w-full'>
            <Container className='relative'>
                <div className='top-[-140px] lg:top-[140px] right-0 lg:absolute relative'>
                    <motion.div
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        className='bg-white shadow-lg rounded-lg w-full lg:w-[550px] lg:max-h-[800px] overflow-y-auto transition-all'
                    >
                        <div className='flex items-center bg-white h-15 overflow-hidden font-semibold text-[#9D9EB7] mobile:text-lg text-2xl shrink-0'>
                            {
                                tabMenu.map((item, idx) => (
                                    <div
                                        className={`flex flex-1 justify-center items-center h-full transition-all hover:bg-[#1E2140] cursor-pointer ${tab === item.tab ? 'bg-primary text-white' : ''}`}
                                        key={idx}
                                        onClick={() => {
                                            setTab(item.tab)
                                            setBlNo('')
                                            setIsOpen(false)
                                        }}
                                    >
                                        <p>{item.title}</p>
                                    </div>
                                ))
                            }
                        </div>
                        {
                            tab === 0 ?
                                <div className='flex flex-col gap-4 tablet:gap-2 p-10 mobile:p-4'>
                                    <div className='flex items-center rounded w-full text-lg'>
                                        {
                                            transportTypeMenu.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`flex-1 flex items-center justify-center gap-1 h-15 rounded text-center border-1 transition-all cursor-pointer
                                ${info.transportType === item.value ? 'text-primary border-primary' : 'text-[#9D9EB7] border-transparent bg-[#F8F8FA]'} mobile:h-10`}
                                                    onClick={() => {
                                                        setInfo({
                                                            transportType: item.value,
                                                            shipmentMode: item.value === 'SEA' ? 'FCL' : '',
                                                        } as IInfo)
                                                    }}
                                                >
                                                    <item.icon fill={info.transportType === item.value ? '#196BFF' : '#9D9EB7'} />
                                                    {item.label}
                                                </div>
                                            ))
                                        }
                                    </div>

                                    {
                                        info.transportType === 'SEA' &&
                                        <div className='flex items-center gap-10 text-lg'>
                                            {
                                                shipment.map((item, idx) => (
                                                    <div
                                                        key={idx}
                                                        className='flex justify-center items-center gap-3 cursor-pointer'
                                                        onClick={() => {
                                                            setInfo(p => ({
                                                                ...p,
                                                                containerType: '',
                                                                amount: null,
                                                                shipmentMode: item
                                                            }))
                                                        }}
                                                    >
                                                        {
                                                            info.shipmentMode === item ?
                                                                <ChkOn /> :
                                                                <ChkOff />
                                                        }
                                                        {item}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    }

                                    <QuoteArea title='출발지'>
                                        <div className='w-full'>
                                            <div className='relative flex items-center gap-4 w-full h-15 tablet:h-10'>
                                                {
                                                    !tempRefresh &&
                                                    <PortSelect
                                                        height={60}
                                                        fontSize={18}
                                                        width='w-full'
                                                        transportType={info.transportType}
                                                        transitAddress={info.originAddress}
                                                        className='flex-1'
                                                        value={info.originId}
                                                        placeholder={'출발지를 검색해주세요.'}
                                                        onChange={(allData) => {
                                                            setInfo(p => ({
                                                                ...p,
                                                                originId: allData.value,
                                                                originCode: allData.label.split(' | ')[0],
                                                                originAddress: allData.label.split(' | ')[1],
                                                            }))
                                                        }}
                                                    />
                                                }
                                                {
                                                    !!info?.originId &&
                                                    <div
                                                        className='right-12 absolute cursor-pointer'
                                                        onClick={() => {
                                                            setInfo(p => ({
                                                                ...p,
                                                                originId: '',
                                                                originCode: '',
                                                                originAddress: '',
                                                            }))
                                                        }}
                                                    >
                                                        <XMark className='w-6' fill='#F00' />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </QuoteArea>

                                    <QuoteArea title='도착지'>
                                        <div className='w-full'>
                                            <div className='relative flex items-center gap-4 w-full h-15 tablet:h-10'>
                                                {
                                                    !tempRefresh &&
                                                    <PortSelect
                                                        height={60}
                                                        fontSize={18}
                                                        position='top'
                                                        width='w-full'
                                                        transportType={info.transportType}
                                                        transitAddress={info.destinationAddress}
                                                        className='flex-1'
                                                        value={info.destinationId}
                                                        placeholder={'도착지를 검색해주세요'}
                                                        onChange={(allData) => {
                                                            setInfo(p => ({
                                                                ...p,
                                                                destinationId: allData.value,
                                                                destinationCode: allData.label.split(' | ')[0],
                                                                destinationAddress: allData.label.split(' | ')[1],
                                                            }))
                                                        }}
                                                    />
                                                }
                                                {
                                                    !!info?.destinationId &&
                                                    <div
                                                        className='right-12 absolute cursor-pointer'
                                                        onClick={() => {
                                                            setInfo(p => ({
                                                                ...p,
                                                                destinationId: '',
                                                                destinationCode: '',
                                                                destinationAddress: '',
                                                            }))
                                                        }}
                                                    >
                                                        <XMark className='w-6' fill='#F00' />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </QuoteArea>

                                    <QuoteArea title='화믈정보'>
                                        <div className='flex gap-2'>
                                            <div className='flex-[1]'>
                                                <CustomInput
                                                    type="number" height={15} fontSize={'lg'} placeholder="수량입력"
                                                    isWhite
                                                    value={info.amount ? String(info.amount) : ''}
                                                    onChange={(e) => {
                                                        if (Number(e.target.value) > 0) {
                                                            setInfo(p => ({
                                                                ...p,
                                                                amount: Number(e.target.value),
                                                            }));
                                                        }
                                                        else if (Number(e.target.value) === 0) {
                                                            setInfo(p => ({
                                                                ...p,
                                                                amount: null,
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {
                                                info.shipmentMode?.includes('FCL') &&
                                                <div className='flex-[1]'>
                                                    <CustomSelect
                                                        position='top'
                                                        height={60}
                                                        fontSize={18}
                                                        option={floatingContainerSelect}
                                                        value={
                                                            info.containerType !== undefined
                                                                ? floatingContainerSelect.find(arr => arr.value === info.containerType)
                                                                : null
                                                        }
                                                        placeholder={'타입선택'}
                                                        onChange={(_, allData) => {
                                                            setInfo(p => ({
                                                                ...p,
                                                                containerType: allData.value,
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            }
                                            {
                                                info.shipmentMode?.includes('LCL') &&
                                                <div className='flex-[1]'>
                                                    <div className='flex items-center px-6 border border-[#9D9EB7] rounded-lg h-full text-lg'>
                                                        CMB
                                                    </div>
                                                </div>
                                            }
                                            {
                                                info.transportType === "AIR" &&
                                                <div className='flex-[1]'>
                                                    <div className='flex items-center px-6 border border-[#9D9EB7] rounded-lg h-full text-lg'>
                                                        KG
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </QuoteArea>

                                    <CustomButton
                                        disabled={!clear}
                                        className='bg-primary shrink-0'
                                        title='실시간 견적 받기'
                                        onClick={saveQuote}
                                    />
                                </div> :
                                <BlSearch
                                    blNo={blNo}
                                    setBlNo={setBlNo}
                                    setIsOpen={setIsOpen}
                                />
                        }
                    </motion.div>

                    <MainQuoteModal
                        userPop={userPop}
                        setUserPop={setUserPop}
                        setTempRefresh={setTempRefresh}
                        info={info}
                        setInfo={setInfo}
                    />
                </div>
            </Container>
        </div>
    )
}

export default FloatingArea